import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BffUserService } from '@canvas/four-r-digital';
import { environment } from '../../environments/environment';

@Component({
  templateUrl: './invalid-permissions.component.html',
  styleUrls: ['./invalid-permissions.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class InvalidPermissionsComponent {
  readonly appName = environment.appName;

  constructor(private readonly bffService: BffUserService) {}

  logout(): void {
    this.bffService.logout();
  }
}
